import React from 'react';
import { array, bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import { get, isEmpty } from 'lodash';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import EsmsDialog from '../../components/EsmsDialog';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

import classes from './InviteUserModal.module.css';

const ValidationSchema = Yup.object().shape({
    role: Yup.string()
        .required()
});

const ManageUserModal = ({
    close,
    clearErrors,
    data,
    open,
    title,
    isLoading,
    toggleLoading,
    errors,
    user,
    ...props
}) => {
    const formik = useFormik({
        initialValues: {
            role: get(user, 'role.id', '')
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const {
                update
            } = props;

            let isUpdated;

            clearErrors();
            setSubmitting(true);

            try {
                if (!isLoading) {
                    toggleLoading(true);
                    isUpdated = update(values);
                }

                if (isUpdated) {
                    handleClose();
                } else {
                    setSubmitting(false);
                    toggleLoading(false);
                }
            } catch (error) {
                setSubmitting(false);
            }
        }
    });

    const sorter = (a, b) => {
        let roleA = a.name.toUpperCase();
        let roleB = b.name.toUpperCase();

        if (roleA < roleB) {
            return -1;
        }
        if (roleA > roleB) {
            return 1;
        }

        return 0;
    };

    const handleClose = () => {
        toggleLoading(false);
        clearErrors();

        close();
    };

    if (isEmpty(user)) return null;

    return (
        <EsmsDialog
            onClose={close}
            disabled={formik.isSubmitting}
            onConfirm={formik.handleSubmit}
            confirmText="Update"
            open={open}
            isLoading={isLoading}
            title={title}
            cancelable={true}
            errors={errors}
            onRendered={formik.handleReset}
        >
            <div className={classes.formColumn}>
                <div className={classes.labelColumn}>
                    <div className={classes.labelHeader}>
                        <img src="/assets/images/usersFlat.svg" alt="Users Icon" />
                        <span>Manage User</span>
                    </div>
                    <div className={classes.labelContent}>
                        <p>
                            Select a new role for the user.
                        </p>
                    </div>
                </div>
                <div className={classes.inputColumn}>
                    <div className={classes.inputs}>
                        <FormControl className={classes.fullWidth}>
                            <InputLabel
                                htmlFor="role"
                                classes={{
                                    error:   classes.error,
                                    focused: classes.labelFocused,
                                    root:    classes.label
                                }}
                                error={Boolean(formik.errors.role) && Boolean(formik.touched.role)}
                            >
                                Role
                            </InputLabel>
                            <Select
                                value={formik.values.role}
                                name="role"
                                id="role"
                                onChange={formik.handleChange}
                                classes={{
                                    root: classes.select
                                }}
                                inputProps={{
                                    onBlur: formik.handleBlur
                                }}
                                MenuProps={{
                                    className: 'usersRoleMenu'
                                }}
                                error={Boolean(formik.errors.role) && Boolean(formik.touched.role)}
                            >
                                {data.roles.sort((a, b) => sorter(a, b)).map(role => {
                                    return (
                                        <MenuItem
                                            className={classes.selectMenuItem}
                                            key={role.id}
                                            value={role.id}
                                        >
                                            {role.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                            {formik.touched.role &&
                             formik.errors.role && <FormHelperText className={classes.error}>{formik.errors.role}</FormHelperText>}
                        </FormControl>
                    </div>
                </div>
            </div>
        </EsmsDialog>
    );
};

ManageUserModal.defaultProps = {
    clearErrors: () => {},
    close:       () => {},
    data:        {},
    errors:      [],
    isLoading:   false,
    open:        false,
    title:       '',
    update:      () => {},
    user:        {}
};

ManageUserModal.propTypes = {
    clearErrors: func,
    close:       func,
    data:        object,
    errors:      array,
    isLoading:   bool,
    open:        bool,
    title:       string,
    update:      func,
    user:        object
};

const mapStateToProps = state => {
    return {
        errors:    state.messages.errors,
        isLoading: state.ui.isLoading
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserModal);
